import styled from 'styled-components';

export const TrackingContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding-top: 20px;
  background-color: transparent; /* Fundo transparente para mesclar com a página */
`;

export const TableWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  padding-right: 10px;

  /* Scrollbar customizada */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate; 
  border-spacing: 0;
  font-family: 'Inter', sans-serif;
`;

export const Th = styled.th`
  position: sticky;
  top: 0;
  background-color: #F4F4F4; /* Cor de fundo exata da sua página para efeito transparente */
  z-index: 10;
  
  text-align: left;
  padding: 16px;
  font-size: 12px;
  font-weight: 500;
  color: #8D8D8D;
  border-bottom: 1px solid transparent; 
  white-space: nowrap;
  cursor: default; 
`;

export const TableRow = styled.tr`
  background-color: #FFFFFF;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f9f9f9;
  }
`;

export const Td = styled.td`
  padding: 16px;
  font-size: 14px;
  color: #303030;
  background-color: #FFFFFF;
  border-bottom: 1px solid #F4F4F4;
  vertical-align: middle;
  white-space: nowrap;

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

export const StatusText = styled.span`
  font-size: 14px;
  color: #303030;
  font-weight: 400;
`;

export const IconCellButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  img {
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  margin-top: auto;
  width: 100%;
`;

export const EmptyStateRow = styled.tr`
  td {
    text-align: center;
    padding: 40px;
    color: #8D8D8D;
    font-size: 14px;
    background-color: #FFFFFF;
  }
`;
export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-size: 18px;
  color: #666;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
`;